import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmInfoIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmInfoIcon = ({ className, ...props }: EmInfoIconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_262_45329)">
      <path
        d="M20.0165 0.680618H2.14148C1.38179 0.680618 0.766479 1.29593 0.766479 2.05562V19.9306C0.766479 20.6903 1.38179 21.3056 2.14148 21.3056H20.0165C20.7762 21.3056 21.3915 20.6903 21.3915 19.9306V2.05562C21.3915 1.29593 20.7762 0.680618 20.0165 0.680618Z"
        fill="#427687"
      />
      <path
        d="M18.9337 0.680618H2.05555C1.3457 0.685775 0.77164 1.25984 0.766483 1.96968V18.7962C0.764765 19.5078 1.34055 20.0836 2.05211 20.0853C2.05383 20.0853 2.05383 20.0853 2.05555 20.0853H18.9165C19.628 20.087 20.2038 19.5112 20.2055 18.7997C20.2055 18.798 20.2055 18.798 20.2055 18.7962V1.96968C20.221 1.27359 19.6676 0.696087 18.9715 0.680618C18.9595 0.680618 18.9457 0.680618 18.9337 0.680618Z"
        fill="#8CAFBF"
      />
      <path
        d="M11.646 18.7275H9.60073C9.37386 18.7241 9.19167 18.5419 9.18823 18.315V8.5525C9.19167 8.32562 9.37386 8.14344 9.60073 8.14H11.6289C11.8557 8.14344 12.0379 8.32562 12.0414 8.5525V18.315C12.0465 18.5384 11.8695 18.7223 11.646 18.7275Z"
        fill="white"
      />
      <path
        d="M10.6148 6.93687C11.6305 6.93687 12.4539 6.11349 12.4539 5.09781C12.4539 4.08212 11.6305 3.25874 10.6148 3.25874C9.59913 3.25874 8.77576 4.08212 8.77576 5.09781C8.77576 6.11349 9.59913 6.93687 10.6148 6.93687Z"
        fill="white"
      />
      <path
        d="M6.90244 2.21031C6.90244 1.815 6.62744 1.69468 5.04619 1.74625C3.72275 1.79781 3.06963 1.9525 2.67432 2.43375C2.279 2.915 2.17588 3.89468 2.15869 5.06343C2.15869 5.88843 2.15869 6.66187 2.58838 6.66187C3.17275 6.66187 3.17275 5.30406 3.654 4.54781C4.58213 3.0525 6.90244 2.72593 6.90244 2.21031Z"
        fill="#B4E1ED"
        opacity="0.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_262_45329">
        <rect
          fill="white"
          height="22"
          width="22"
        />
      </clipPath>
    </defs>
  </svg>
);

export default EmInfoIcon;
